import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from '@/lib/utils';

interface AnimatedFormErrorProps {
  children?: React.ReactNode;
  className?: string;
}

export const AnimatedFormError: React.FC<AnimatedFormErrorProps> = ({ children, className }) => {
  return (
    <AnimatePresence initial={false} mode="wait">
      {children ? (
        <motion.div
          layout
          key="error"
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
          className={cn('hidden md:block w-full text-left overflow-hidden', className)}
          aria-live="polite"
          role="status"
        >
          <div className="pt-1">
            {children}
          </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
